// extracted by mini-css-extract-plugin
export default {"errIcon":"src-components-ErrorModal-ErrorModalTitle__errIcon--GMqbk"};